import { 
    APPLICATION_STATUS_APPROVED_ISSUED,
    APPLICATION_STATUS_DENIED,
    APPLICATION_STATUS_OPENED,
    APPLICATION_STATUS_PENDING,
    APPLICATION_STATUS_PENDING_PAYMENT,
    APPLICATION_STATUS_UNDER_REVIEW,
    APPLICATION_STATUS_WITHDRAWN_APPROVED,
    APPLICATION_STATUS_WITHDRAWN_BY_CLIENT,
    APPLICATION_TYPE_COLLECTION_AGENCY,
    APPLICATION_TYPE_COLLECTOR,
    APPLICATION_TYPE_DEBT_MANAGEMENT_AGENCY,
    APPLICATION_TYPE_DEBT_MANAGEMENT_AGENT,
    APPLICATION_TYPE_MORTGAGE_ASSOCIATE_BROKER_LICENCE,
    APPLICATION_TYPE_MORTGAGE_BROKERAGE_LICENCE,
    APPLICATION_TYPE_MORTGAGE_INDIVIDUAL_BROKER_LICENCE,
    APPLICATION_TYPE_MORTGAGE_LENDER_LICENCE,
    APPLICATION_TYPE_MORTGAGE_PRINCIPAL_BROKER_LICENCE,
    APPLICATION_TYPE_MORTGAGE_ADMINISTRATOR_LICENCE,
    LICENCE_SUB_TYPE_ASSOCIATE_MORTGAGE_BROKER_NEW_APPLICATION,
    LICENCE_SUB_TYPE_COLLECTION_AGENCY_APPLICATION, 
    LICENCE_SUB_TYPE_COLLECTION_AGENCY_RENEWAL, 
    LICENCE_SUB_TYPE_COLLECTION_COLLECTOR_APPLICATION, 
    LICENCE_SUB_TYPE_COLLECTION_COLLECTOR_RENEWAL, 
    LICENCE_SUB_TYPE_DEBT_MANAGEMENT_APPLICATION, 
    LICENCE_SUB_TYPE_DEBT_MANAGEMENT_INDIVIDUAL_APPLICATION, 
    LICENCE_SUB_TYPE_DEBT_MANAGEMENT_INDIVIDUAL_RENEWAL, 
    LICENCE_SUB_TYPE_DEBT_MANAGEMENT_RENEWAL, 
    LICENCE_SUB_TYPE_MORTGAGE_BROKERAGE_NEW_APPLICATION,
    LICENCE_SUB_TYPE_MORTGAGE_BROKER_NEW_APPLICATION,
    LICENCE_SUB_TYPE_MORTGAGE_LENDER_NEW_APPLICATION,
    LICENCE_SUB_TYPE_MORTGAGE_ADMINISTRATOR_NEW_APPLICATION,
    LICENCE_SUB_TYPE_PRINCIPAL_BROKER_NEW_APPLICATION,
    LICENCE_SUB_TYPE_MORTGAGE_BROKERAGE_RENEWAL_APPLICATION,
    LICENCE_SUB_TYPE_MORTGAGE_BROKER_RENEWAL_APPLICATION,
    LICENCE_SUB_TYPE_ASSOCIATE_MORTGAGE_BROKER_RENEWAL_APPLICATION,
    LICENCE_SUB_TYPE_MORTGAGE_LENDER_RENEWAL_APPLICATION,
    LICENCE_SUB_TYPE_MORTGAGE_ADMINISTRATOR_RENEWAL_APPLICATION,
    LICENCE_SUB_TYPE_PRINCIPAL_BROKER_RENEWAL_APPLICATION,
    LICENCE_SUB_TYPE_MORTGAGE_ADMINISTRATOR_CHANGE_APPLICATION,
    LICENCE_SUB_TYPE_MORTGAGE_LENDER_CHANGE_APPLICATION,
    APPLICATION_STATUS_UNREAD,
    APPLICATION_STATUS_PENDING_AGENCY,
    APPLICATION_TYPE_INDIVIDUAL_PRINCIPAL_BROKER_LICENCE,
    APPLICATION_TYPE_INDIVIDUAL_COMPLIANCE_OFFICER_LICENCE,
    LICENCE_SUB_TYPE_INDIVIDUAL_PRINCIPAL_BROKER_APPLICATION,
    LICENCE_SUB_TYPE_INDIVIDUAL_COMPLIANCE_OFFICER_APPLICATION,
    APPLICATION_TYPE_INDIVIDUAL_PRINCIPAL_BROKER_RETENTION_LICENCE,
    APPLICATION_TYPE_INDIVIDUAL_COMPLIANCE_OFFICER_RETENTION_LICENCE,
    LICENCE_SUB_TYPE_INDIVIDUAL_PRINCIPAL_BROKER_RETENTION_APPLICATION,
    LICENCE_SUB_TYPE_INDIVIDUAL_COMPLIANCE_OFFICER_RETENTION_APPLICATION,
    CHANGE_REQUEST_TYPE_MAIN_AGENT,
    CHANGE_REQUEST_STATUS_PENDING,
    LICENCE_SUB_TYPE_MORTGAGE_BROKERAGE_CHANGE_APPLICATION,
} from "../../app/constants";
import { fullName } from "../../app/utils";

export function isRenewalTypeLicencingSubType(licencingSubType) {
    return (
        licencingSubType === LICENCE_SUB_TYPE_COLLECTION_AGENCY_RENEWAL
        || licencingSubType === LICENCE_SUB_TYPE_DEBT_MANAGEMENT_RENEWAL
        || licencingSubType === LICENCE_SUB_TYPE_COLLECTION_COLLECTOR_RENEWAL
        || licencingSubType === LICENCE_SUB_TYPE_DEBT_MANAGEMENT_INDIVIDUAL_RENEWAL
        || licencingSubType === LICENCE_SUB_TYPE_MORTGAGE_BROKERAGE_RENEWAL_APPLICATION
        || licencingSubType === LICENCE_SUB_TYPE_MORTGAGE_BROKER_RENEWAL_APPLICATION
        || licencingSubType === LICENCE_SUB_TYPE_PRINCIPAL_BROKER_RENEWAL_APPLICATION
        || licencingSubType === LICENCE_SUB_TYPE_ASSOCIATE_MORTGAGE_BROKER_RENEWAL_APPLICATION
        || licencingSubType === LICENCE_SUB_TYPE_MORTGAGE_ADMINISTRATOR_RENEWAL_APPLICATION
        || licencingSubType === LICENCE_SUB_TYPE_MORTGAGE_LENDER_RENEWAL_APPLICATION
    )
}

export function isRenewalTypeApplication(application) {
    if(!application)
        return false

    return isRenewalTypeLicencingSubType(application.licencingSubType)
}

export const isChangeRequestTypeLicencingSubType = (licencingSubType) => {
    return (
        licencingSubType === LICENCE_SUB_TYPE_MORTGAGE_BROKERAGE_CHANGE_APPLICATION
        || licencingSubType === LICENCE_SUB_TYPE_MORTGAGE_LENDER_CHANGE_APPLICATION
        || licencingSubType === LICENCE_SUB_TYPE_MORTGAGE_ADMINISTRATOR_CHANGE_APPLICATION
    )
}

export const isChangeRequestTypeApplication = (application) => {
    if (!application)
        return false

    return isChangeRequestTypeLicencingSubType(application.licencingSubType)
}

export function isAgencyTypeApplication (application) {
    if(!application)
        return false
    
    return (
        application.licencingSubType === LICENCE_SUB_TYPE_COLLECTION_AGENCY_APPLICATION
        || application.licencingSubType === LICENCE_SUB_TYPE_COLLECTION_AGENCY_RENEWAL
        || application.licencingSubType === LICENCE_SUB_TYPE_DEBT_MANAGEMENT_APPLICATION
        || application.licencingSubType === LICENCE_SUB_TYPE_DEBT_MANAGEMENT_RENEWAL
        || application.licencingSubType === LICENCE_SUB_TYPE_MORTGAGE_BROKERAGE_NEW_APPLICATION
        || application.licencingSubType === LICENCE_SUB_TYPE_MORTGAGE_BROKERAGE_CHANGE_APPLICATION
        || application.licencingSubType === LICENCE_SUB_TYPE_MORTGAGE_LENDER_NEW_APPLICATION
        || application.licencingSubType === LICENCE_SUB_TYPE_MORTGAGE_ADMINISTRATOR_NEW_APPLICATION
        || application.licencingSubType === LICENCE_SUB_TYPE_MORTGAGE_BROKERAGE_RENEWAL_APPLICATION
        || application.licencingSubType === LICENCE_SUB_TYPE_MORTGAGE_LENDER_RENEWAL_APPLICATION
        || application.licencingSubType === LICENCE_SUB_TYPE_MORTGAGE_ADMINISTRATOR_RENEWAL_APPLICATION
        || application.licencingSubType === LICENCE_SUB_TYPE_MORTGAGE_LENDER_CHANGE_APPLICATION
        || application.licencingSubType === LICENCE_SUB_TYPE_MORTGAGE_ADMINISTRATOR_CHANGE_APPLICATION
        || application.licencingSubType === LICENCE_SUB_TYPE_INDIVIDUAL_COMPLIANCE_OFFICER_APPLICATION
        || application.licencingSubType === LICENCE_SUB_TYPE_INDIVIDUAL_PRINCIPAL_BROKER_APPLICATION
        || application.licencingSubType === LICENCE_SUB_TYPE_INDIVIDUAL_COMPLIANCE_OFFICER_RETENTION_APPLICATION
        || application.licencingSubType === LICENCE_SUB_TYPE_INDIVIDUAL_PRINCIPAL_BROKER_RETENTION_APPLICATION
    )
}

export function isIndividualTypeApplication(application) {
    
    if(!application)
        return false

    return (
        application.licencingSubType === LICENCE_SUB_TYPE_COLLECTION_COLLECTOR_APPLICATION
            || application.licencingSubType === LICENCE_SUB_TYPE_COLLECTION_COLLECTOR_RENEWAL
            || application.licencingSubType === LICENCE_SUB_TYPE_DEBT_MANAGEMENT_INDIVIDUAL_APPLICATION
            || application.licencingSubType === LICENCE_SUB_TYPE_DEBT_MANAGEMENT_INDIVIDUAL_RENEWAL
            || application.licencingSubType === LICENCE_SUB_TYPE_PRINCIPAL_BROKER_NEW_APPLICATION
            || application.licencingSubType === LICENCE_SUB_TYPE_ASSOCIATE_MORTGAGE_BROKER_NEW_APPLICATION
            || application.licencingSubType === LICENCE_SUB_TYPE_MORTGAGE_BROKER_NEW_APPLICATION
            || application.licencingSubType === LICENCE_SUB_TYPE_PRINCIPAL_BROKER_RENEWAL_APPLICATION
            || application.licencingSubType === LICENCE_SUB_TYPE_ASSOCIATE_MORTGAGE_BROKER_RENEWAL_APPLICATION
            || application.licencingSubType === LICENCE_SUB_TYPE_MORTGAGE_BROKER_RENEWAL_APPLICATION
    )
}

export function applicationTypeFromLicenceSubType (licenceSubType) {
    let applicationType

    switch(licenceSubType) { 
        case LICENCE_SUB_TYPE_COLLECTION_AGENCY_APPLICATION : 
        case LICENCE_SUB_TYPE_COLLECTION_AGENCY_RENEWAL : 
            applicationType = APPLICATION_TYPE_COLLECTION_AGENCY
            break
        case LICENCE_SUB_TYPE_COLLECTION_COLLECTOR_APPLICATION : 
        case LICENCE_SUB_TYPE_COLLECTION_COLLECTOR_RENEWAL : 
            applicationType = APPLICATION_TYPE_COLLECTOR
            break
        case LICENCE_SUB_TYPE_DEBT_MANAGEMENT_APPLICATION : 
        case LICENCE_SUB_TYPE_DEBT_MANAGEMENT_RENEWAL : 
            applicationType = APPLICATION_TYPE_DEBT_MANAGEMENT_AGENCY
            break
        case LICENCE_SUB_TYPE_DEBT_MANAGEMENT_INDIVIDUAL_APPLICATION : 
        case LICENCE_SUB_TYPE_DEBT_MANAGEMENT_INDIVIDUAL_RENEWAL : 
            applicationType = APPLICATION_TYPE_DEBT_MANAGEMENT_AGENT
            break
        case LICENCE_SUB_TYPE_MORTGAGE_BROKERAGE_NEW_APPLICATION : 
        case LICENCE_SUB_TYPE_MORTGAGE_BROKERAGE_RENEWAL_APPLICATION : 
        case LICENCE_SUB_TYPE_MORTGAGE_BROKERAGE_CHANGE_APPLICATION :
            applicationType = APPLICATION_TYPE_MORTGAGE_BROKERAGE_LICENCE
            break
        case LICENCE_SUB_TYPE_PRINCIPAL_BROKER_NEW_APPLICATION : 
        case LICENCE_SUB_TYPE_PRINCIPAL_BROKER_RENEWAL_APPLICATION : 
            applicationType = APPLICATION_TYPE_MORTGAGE_PRINCIPAL_BROKER_LICENCE
            break
        case LICENCE_SUB_TYPE_ASSOCIATE_MORTGAGE_BROKER_NEW_APPLICATION : 
        case LICENCE_SUB_TYPE_ASSOCIATE_MORTGAGE_BROKER_RENEWAL_APPLICATION : 
            applicationType = APPLICATION_TYPE_MORTGAGE_ASSOCIATE_BROKER_LICENCE
            break
        case LICENCE_SUB_TYPE_MORTGAGE_BROKER_NEW_APPLICATION : 
        case LICENCE_SUB_TYPE_MORTGAGE_BROKER_RENEWAL_APPLICATION : 
            applicationType = APPLICATION_TYPE_MORTGAGE_INDIVIDUAL_BROKER_LICENCE
            break
        case LICENCE_SUB_TYPE_MORTGAGE_LENDER_NEW_APPLICATION : 
        case LICENCE_SUB_TYPE_MORTGAGE_LENDER_RENEWAL_APPLICATION :
        case LICENCE_SUB_TYPE_MORTGAGE_LENDER_CHANGE_APPLICATION : 
            applicationType = APPLICATION_TYPE_MORTGAGE_LENDER_LICENCE
            break
        case LICENCE_SUB_TYPE_MORTGAGE_ADMINISTRATOR_NEW_APPLICATION : 
        case LICENCE_SUB_TYPE_MORTGAGE_ADMINISTRATOR_RENEWAL_APPLICATION : 
        case LICENCE_SUB_TYPE_MORTGAGE_ADMINISTRATOR_CHANGE_APPLICATION : 
            applicationType = APPLICATION_TYPE_MORTGAGE_ADMINISTRATOR_LICENCE
            break
        case LICENCE_SUB_TYPE_INDIVIDUAL_PRINCIPAL_BROKER_APPLICATION:
            applicationType = APPLICATION_TYPE_INDIVIDUAL_PRINCIPAL_BROKER_LICENCE;
            break;
        case LICENCE_SUB_TYPE_INDIVIDUAL_COMPLIANCE_OFFICER_APPLICATION:
            applicationType = APPLICATION_TYPE_INDIVIDUAL_COMPLIANCE_OFFICER_LICENCE;
            break;
        case LICENCE_SUB_TYPE_INDIVIDUAL_PRINCIPAL_BROKER_RETENTION_APPLICATION:
            applicationType = APPLICATION_TYPE_INDIVIDUAL_PRINCIPAL_BROKER_RETENTION_LICENCE;
            break;
        case LICENCE_SUB_TYPE_INDIVIDUAL_COMPLIANCE_OFFICER_RETENTION_APPLICATION:
            applicationType = APPLICATION_TYPE_INDIVIDUAL_COMPLIANCE_OFFICER_RETENTION_LICENCE;
            break;
        default : 
            applicationType = APPLICATION_TYPE_COLLECTION_AGENCY
            break
    }

    return applicationType
}

export function titleStringFromLicenceSubType(subType) { 

    if(!subType)
      return ""
    
    switch(subType) { 
        case LICENCE_SUB_TYPE_COLLECTION_AGENCY_APPLICATION :
        case LICENCE_SUB_TYPE_COLLECTION_AGENCY_RENEWAL :
            return "Collection Agency Licence"
        case LICENCE_SUB_TYPE_COLLECTION_COLLECTOR_APPLICATION : 
        case LICENCE_SUB_TYPE_COLLECTION_COLLECTOR_RENEWAL : 
            return "Collector Licence"
        case LICENCE_SUB_TYPE_DEBT_MANAGEMENT_APPLICATION : 
        case LICENCE_SUB_TYPE_DEBT_MANAGEMENT_RENEWAL : 
            return "Debt Management Agency Licence"
        case LICENCE_SUB_TYPE_DEBT_MANAGEMENT_INDIVIDUAL_APPLICATION : 
        case LICENCE_SUB_TYPE_DEBT_MANAGEMENT_INDIVIDUAL_RENEWAL : 
            return "Debt Management Agent Licence"
        case LICENCE_SUB_TYPE_MORTGAGE_BROKERAGE_NEW_APPLICATION :
        case LICENCE_SUB_TYPE_MORTGAGE_BROKERAGE_RENEWAL_APPLICATION :
        case LICENCE_SUB_TYPE_MORTGAGE_BROKERAGE_CHANGE_APPLICATION :
            return "Mortgage Brokerage Licence"
        case LICENCE_SUB_TYPE_PRINCIPAL_BROKER_NEW_APPLICATION :
        case LICENCE_SUB_TYPE_PRINCIPAL_BROKER_RENEWAL_APPLICATION :
            return "Principal Broker Licence"
        case LICENCE_SUB_TYPE_MORTGAGE_BROKER_NEW_APPLICATION : 
        case LICENCE_SUB_TYPE_MORTGAGE_BROKER_RENEWAL_APPLICATION :
            return "Mortgage Broker Licence"
        case LICENCE_SUB_TYPE_ASSOCIATE_MORTGAGE_BROKER_NEW_APPLICATION : 
        case LICENCE_SUB_TYPE_ASSOCIATE_MORTGAGE_BROKER_RENEWAL_APPLICATION : 
            return "Associate Mortgage Broker Licence"
        case LICENCE_SUB_TYPE_MORTGAGE_LENDER_NEW_APPLICATION : 
        case LICENCE_SUB_TYPE_MORTGAGE_LENDER_RENEWAL_APPLICATION : 
            return "Mortgage Lender Licence"
        case LICENCE_SUB_TYPE_MORTGAGE_ADMINISTRATOR_NEW_APPLICATION : 
        case LICENCE_SUB_TYPE_MORTGAGE_ADMINISTRATOR_RENEWAL_APPLICATION : 
            return "Mortgage Administrator Licence"
        case LICENCE_SUB_TYPE_MORTGAGE_LENDER_CHANGE_APPLICATION : 
            return "Mortgage Lender Licence"
        case LICENCE_SUB_TYPE_MORTGAGE_ADMINISTRATOR_CHANGE_APPLICATION : 
            return "Mortgage Administrator Licence"
        case LICENCE_SUB_TYPE_INDIVIDUAL_COMPLIANCE_OFFICER_APPLICATION :
            return "Compliance Officer Individual Application";
        case LICENCE_SUB_TYPE_INDIVIDUAL_PRINCIPAL_BROKER_APPLICATION :
            return "Principal Broker Individual Application";
        case LICENCE_SUB_TYPE_INDIVIDUAL_COMPLIANCE_OFFICER_RETENTION_APPLICATION :
            return "Compliance Officer Individual Change Application";
        case LICENCE_SUB_TYPE_INDIVIDUAL_PRINCIPAL_BROKER_RETENTION_APPLICATION :
            return "Principal Broker Individual Change Application";
        default :
            return subType;
    }
}

/*
 Below function checks the status strings which are expected to be set after
 application is "processed" by the business licensing team admin.
 
 APPLICATION_STATUS_PENDING( = "PENDING") status falls under "still in progress" category, becuase it is marked
 when application is missing something and admin is waiting for that information 
 from the applicant 
*/
export function isApplicationStatusForProcessedApplication(applicationStatus) {
    return (applicationStatus === APPLICATION_STATUS_APPROVED_ISSUED
            || applicationStatus === APPLICATION_STATUS_DENIED
            || applicationStatus === APPLICATION_STATUS_WITHDRAWN_BY_CLIENT
            || applicationStatus === APPLICATION_STATUS_WITHDRAWN_APPROVED)
}

export function isApplicationProcessed(applicationItem) {
    if(!applicationItem)
        return false
    
    return isApplicationStatusForProcessedApplication(applicationItem.applicationStatus)
}



/*
 Below function checks if the given application is currently being processed either by same 
 or other business licence admin

 APPLICATION_STATUS_PENDING( = "PENDING") status falls under "still in progress" category, becuase it is marked
 when application is missing something and admin is waiting for that information 
 from the applicant
*/
export function isApplicationProcessingInProgress(applicationItem) {
    if(!applicationItem)
        return false

    return (applicationItem.applicationStatus === APPLICATION_STATUS_PENDING
            || applicationItem.applicationStatus === APPLICATION_STATUS_OPENED
            || applicationItem.applicationStatus === APPLICATION_STATUS_UNDER_REVIEW
            || applicationItem.applicationStatus === APPLICATION_STATUS_UNREAD
            || applicationItem.applicationStatus === APPLICATION_STATUS_PENDING_AGENCY)
}
/*
 Below function returns the name of the given entityId. 
 The search is from the input array, which is expected to be 
 people array received in RJSC responpse.
*/
export function entityNameFromEntityId(peopleList, entityId) {
    let peopleObj = null

    for(let i = 0; i < peopleList?.length; i++) { 
        const people = peopleList[i]

        // + is added to compare the numbers
        if(+people.entityId === +entityId) { 
            peopleObj = people
            break
        }
    }

    return fullName(peopleObj)
}

/*
 Below function returns the name of the given entityId. 
 The search is from the input array, which is expected to be 
 people array received in RJSC responpse.
*/
export function rjscOfficerObjFromEntityId(peopleList, entityId) {
    let peopleObj = null

    for(let i = 0; i < peopleList?.length; i++) { 
        const people = peopleList[i]

        // + is added to compare the numbers
        if(+people.entityId === +entityId) { 
            peopleObj = people
            break
        }
    }

    return peopleObj
}

/*
 Below function returns true for application which is from any of the 
 mortgage flows
*/
export function isLenderTypeApplication(applicationType) { 
    return (applicationType === APPLICATION_TYPE_MORTGAGE_LENDER_LICENCE)
}

export function isAdministratorTypeApplication(applicationType) { 
    return (applicationType === APPLICATION_TYPE_MORTGAGE_ADMINISTRATOR_LICENCE)
}

export function isMortgageTypeApplication(applicationType) { 
    return (applicationType === APPLICATION_TYPE_MORTGAGE_BROKERAGE_LICENCE || 
            applicationType === APPLICATION_TYPE_MORTGAGE_INDIVIDUAL_BROKER_LICENCE || 
            applicationType === APPLICATION_TYPE_MORTGAGE_ASSOCIATE_BROKER_LICENCE || 
            applicationType === APPLICATION_TYPE_MORTGAGE_PRINCIPAL_BROKER_LICENCE || 
            applicationType === APPLICATION_TYPE_INDIVIDUAL_PRINCIPAL_BROKER_LICENCE ||
            applicationType === APPLICATION_TYPE_INDIVIDUAL_COMPLIANCE_OFFICER_LICENCE ||
            applicationType === APPLICATION_TYPE_INDIVIDUAL_PRINCIPAL_BROKER_RETENTION_LICENCE ||
            applicationType === APPLICATION_TYPE_INDIVIDUAL_COMPLIANCE_OFFICER_RETENTION_LICENCE 
            )
}

export function isMortgageMainAgentTypeApplication(applicationType) {
    return (applicationType === APPLICATION_TYPE_INDIVIDUAL_PRINCIPAL_BROKER_LICENCE
            || applicationType === APPLICATION_TYPE_INDIVIDUAL_PRINCIPAL_BROKER_RETENTION_LICENCE
            || applicationType === APPLICATION_TYPE_INDIVIDUAL_COMPLIANCE_OFFICER_LICENCE
            || applicationType === APPLICATION_TYPE_INDIVIDUAL_COMPLIANCE_OFFICER_RETENTION_LICENCE)
}

export function isIndividaulPrincipalBrokerApplication(applicationType) {
    return (applicationType === APPLICATION_TYPE_INDIVIDUAL_PRINCIPAL_BROKER_LICENCE
            || applicationType === APPLICATION_TYPE_INDIVIDUAL_PRINCIPAL_BROKER_RETENTION_LICENCE)
}

export function isCollectionTypeApplication(applicationType) {
    return (applicationType === APPLICATION_TYPE_COLLECTION_AGENCY || 
                applicationType === APPLICATION_TYPE_COLLECTOR || 
                applicationType === APPLICATION_TYPE_DEBT_MANAGEMENT_AGENCY || 
                applicationType === APPLICATION_TYPE_DEBT_MANAGEMENT_AGENT)
}

export function isCollectionOrDebtAgencyLicence(licencingSubType) {
    return (licencingSubType === LICENCE_SUB_TYPE_COLLECTION_AGENCY_APPLICATION ||
        licencingSubType === LICENCE_SUB_TYPE_COLLECTION_AGENCY_RENEWAL ||
        licencingSubType === LICENCE_SUB_TYPE_DEBT_MANAGEMENT_APPLICATION ||
        licencingSubType === LICENCE_SUB_TYPE_DEBT_MANAGEMENT_RENEWAL)

}

/*
  Below function decides if the given application is to supposed to be added
  in the payment computation or not.

  The application is ready for payment when the data is reviewed in the application
  review screen and the status is set to the PENDING_PAYMENT
*/
export function isReadyForPayment(applicationItem) {
    if(!applicationItem)
        return false
    
    // for now, only the mra flows has 'userApplicationReviewComplete' getting set
    // in the application review page.
    if(isMortgageTypeApplication(applicationTypeFromLicenceSubType(applicationItem.licencingSubType))) {
        return (applicationItem.businessLicenceData?.userApplicationReviewComplete && 
                (!applicationItem.applicationStatus || 
                    applicationItem.applicationStatus === APPLICATION_STATUS_PENDING_PAYMENT)) 
    }

    // for the rest of the application types
    return  (!applicationItem.applicationStatus || 
                applicationItem.applicationStatus === APPLICATION_STATUS_PENDING_PAYMENT)
}

/* 
  A utility function to find out operating name of the busines. 
  
  The input parameter can be the root application json or 
  the application data json
*/
export function companyOperatingName (application) {

    let applicationData = application
    let name = ""

    if(application.businessLicenceData) {
        applicationData = application.businessLicenceData
    }
    
    /* 
     - If businessOwner is present, then the businessName in the entity
       is the owner name, otherwise the operating name should be empty
    */
    if(applicationData?.companyRjscDetails?.businessData?.businessOwner) {
      name = applicationData?.companyRjscDetails?.businessEntity?.businessName  
    }

    return name
}

export const renewalRelatedLicenceSubType = (licencingSubType) => {
    switch(licencingSubType) {
        case LICENCE_SUB_TYPE_COLLECTION_AGENCY_APPLICATION : 
            return LICENCE_SUB_TYPE_COLLECTION_AGENCY_RENEWAL
        case LICENCE_SUB_TYPE_DEBT_MANAGEMENT_APPLICATION : 
            return LICENCE_SUB_TYPE_DEBT_MANAGEMENT_RENEWAL
        case LICENCE_SUB_TYPE_MORTGAGE_BROKERAGE_NEW_APPLICATION:
            return LICENCE_SUB_TYPE_MORTGAGE_BROKERAGE_RENEWAL_APPLICATION
        case LICENCE_SUB_TYPE_MORTGAGE_ADMINISTRATOR_NEW_APPLICATION : 
            return LICENCE_SUB_TYPE_MORTGAGE_ADMINISTRATOR_RENEWAL_APPLICATION
        case LICENCE_SUB_TYPE_MORTGAGE_LENDER_NEW_APPLICATION : 
            return LICENCE_SUB_TYPE_MORTGAGE_LENDER_RENEWAL_APPLICATION
        case LICENCE_SUB_TYPE_PRINCIPAL_BROKER_NEW_APPLICATION:
            return LICENCE_SUB_TYPE_PRINCIPAL_BROKER_RENEWAL_APPLICATION
        case LICENCE_SUB_TYPE_MORTGAGE_BROKER_NEW_APPLICATION:
            return LICENCE_SUB_TYPE_MORTGAGE_BROKER_RENEWAL_APPLICATION
        case LICENCE_SUB_TYPE_ASSOCIATE_MORTGAGE_BROKER_NEW_APPLICATION:
            return LICENCE_SUB_TYPE_ASSOCIATE_MORTGAGE_BROKER_RENEWAL_APPLICATION
        default :
            return licencingSubType
    }
}

export const changeRequestRelatedLicenceSubType = (licencingSubType) => {
    switch(licencingSubType) {
        case LICENCE_SUB_TYPE_MORTGAGE_BROKERAGE_NEW_APPLICATION:
        case LICENCE_SUB_TYPE_MORTGAGE_BROKERAGE_RENEWAL_APPLICATION:
            return LICENCE_SUB_TYPE_MORTGAGE_BROKERAGE_CHANGE_APPLICATION
        case LICENCE_SUB_TYPE_MORTGAGE_ADMINISTRATOR_NEW_APPLICATION : 
        case LICENCE_SUB_TYPE_MORTGAGE_ADMINISTRATOR_RENEWAL_APPLICATION :
            return LICENCE_SUB_TYPE_MORTGAGE_ADMINISTRATOR_CHANGE_APPLICATION
        case LICENCE_SUB_TYPE_MORTGAGE_LENDER_NEW_APPLICATION : 
        case LICENCE_SUB_TYPE_MORTGAGE_LENDER_RENEWAL_APPLICATION : 
            return LICENCE_SUB_TYPE_MORTGAGE_LENDER_CHANGE_APPLICATION
        default :
            return licencingSubType
    }
}

export const revertChangeRequestRelatedLicenceSubType = (licencingSubType) => {
    switch(licencingSubType) {
        case LICENCE_SUB_TYPE_MORTGAGE_BROKERAGE_CHANGE_APPLICATION :
            return LICENCE_SUB_TYPE_MORTGAGE_BROKERAGE_NEW_APPLICATION;
        case LICENCE_SUB_TYPE_MORTGAGE_ADMINISTRATOR_CHANGE_APPLICATION :
            return LICENCE_SUB_TYPE_MORTGAGE_ADMINISTRATOR_NEW_APPLICATION
        case LICENCE_SUB_TYPE_MORTGAGE_LENDER_CHANGE_APPLICATION : 
            return LICENCE_SUB_TYPE_MORTGAGE_LENDER_NEW_APPLICATION
        default :
            return licencingSubType
    }
}

export const changeMainAgentLicenceSubTypeForApproval = (licencingSubType) => {
    switch(licencingSubType) {
        case LICENCE_SUB_TYPE_INDIVIDUAL_PRINCIPAL_BROKER_APPLICATION:
            return LICENCE_SUB_TYPE_INDIVIDUAL_PRINCIPAL_BROKER_RETENTION_APPLICATION
        case LICENCE_SUB_TYPE_INDIVIDUAL_COMPLIANCE_OFFICER_APPLICATION : 
            return LICENCE_SUB_TYPE_INDIVIDUAL_COMPLIANCE_OFFICER_RETENTION_APPLICATION
        default :
            return licencingSubType
    }
}

export function isMortgageBrokerRenewalDue(application) {
    
}

export function isPaymentProcessedSuccessfully(application) {
    if(!application) {
        return false
    }
    const { applicationStatus } = application
    return (applicationStatus !== APPLICATION_STATUS_PENDING_PAYMENT)
}

export function newMainAgentChangeRequestWithData(changeRequestData) { 
    return {
        changeRequestType: CHANGE_REQUEST_TYPE_MAIN_AGENT,
        createdBy: "",
        createdDateTime: Date.now(),
        submittedDateTime: null,
        userApplicationReviewComplete: false,
        changeRequestStatus: CHANGE_REQUEST_STATUS_PENDING,
        changeRequestData
    }
}

export function isNonCollectionOrDebtAgencyApplication(application) {
    if (application?.licencingSubType === LICENCE_SUB_TYPE_MORTGAGE_BROKERAGE_NEW_APPLICATION ||
        application?.licencingSubType === LICENCE_SUB_TYPE_MORTGAGE_LENDER_NEW_APPLICATION ||
        application?.licencingSubType === LICENCE_SUB_TYPE_MORTGAGE_ADMINISTRATOR_NEW_APPLICATION ||
        application?.licencingSubType === LICENCE_SUB_TYPE_MORTGAGE_BROKERAGE_RENEWAL_APPLICATION ||
        application?.licencingSubType === LICENCE_SUB_TYPE_MORTGAGE_LENDER_RENEWAL_APPLICATION ||
        application?.licencingSubType === LICENCE_SUB_TYPE_MORTGAGE_ADMINISTRATOR_RENEWAL_APPLICATION
    ) {
        return true
    }

    return false;
}

export function canShowLoginChangeButton(application) {
    return isNonCollectionOrDebtAgencyApplication(application)
}

export function isCepRipExpiryYearSameAsRenewalYearForAgentApp(agentApplication, licenceTypeInfo) {
    const cepRipExpiryDate = agentApplication?.cepRipExpiryDate;
    const renewalStartDate = licenceTypeInfo?.renewalStartDate;
    if(cepRipExpiryDate && renewalStartDate) {

      const cepDate = new Date(cepRipExpiryDate)
      const renewalDate = new Date(renewalStartDate)
      const cepYear = cepDate.getFullYear();
      const renewalYear = renewalDate.getFullYear();
      if(cepYear === renewalYear) {
        return true
      }
      return false;
    }
    console.log("Valid dates not found");
    return false;
}